import React, { Fragment } from 'react';
import Navbar from '../../@layout/NavBar';
import ViewControl from '../../@common/ViewControl';
import AppBar from '../../@layout/AppBar';
import ClassroomOptionsMenu from './components/ClassroomOptionsMenu';
import AddStudentsModal from '../Classrooms/modals/AddStudentsModal';
import { ModuleProps } from 'types';
import AddCreateButton from 'components/@common/Buttons/AddCreateButton';
import useStore from 'store';
import { useTranslation } from 'react-i18next';
import useRouteAction from 'hooks/route-action/use-route-action';
import { ClassroomModalRouteAction } from '../types';
import { Classroom } from 'types/schema-generated-types';
import WithPrivilegedUser from 'components/@layout/WithPrivilegedUser';
import Config from 'config';
import { AlertVariant } from 'types/enums';
import { useParams } from 'react-router-dom';

const { privilegesGroups } = Config;

const HeaderBar: React.FC<ModuleProps & {
  setLoading: (value: boolean) => void;
  classroom: Classroom;
  viewControl?: boolean;
}> = ({ setLoading, classroom, viewControl, ...props }) => {
  const [, { openFullModal, closeModal, openAlert }] = useStore();
  const { classroomId } = useParams<any>();
  const { t } = useTranslation(props.id);
  const handleClose = (success?: boolean): void => {
    closeModal();
    if (success) {
      openAlert({
        variant: AlertVariant.SUCCESS,
        title: t('Students Added'),
        text: t('You successfully added students to your class.'),
        onClose: () => window.location.reload()
      });
    }
  };
  const handleOpenModal = (): void => {
    openFullModal({
      title: t('Add Students'),
      body: <AddStudentsModal onClose={handleClose} />,
      routeAction: ClassroomModalRouteAction.ADD_STUDENTS,
      routeParams: { classroomId }
    });
  };

  useRouteAction(({ action }) => {
    if (!action) return;
    switch (action) {
      case ClassroomModalRouteAction.ADD_STUDENTS:
        return handleOpenModal();

      default:
        return null;
    }
  });

  return (
    <Fragment>
      <AppBar {...props}>
        {!classroom.dateArchived && (
          <WithPrivilegedUser
            privileges={privilegesGroups.createStudent}
            context={{ classroomId: classroom.id, organizationId: classroom.organizationId }}
          >
            <AddCreateButton onClick={handleOpenModal}>{t('Add Students')}</AddCreateButton>
          </WithPrivilegedUser>
        )}
        <ClassroomOptionsMenu setLoading={setLoading} classroom={classroom || {}} {...props} />
      </AppBar>
      <Navbar {...props}>{viewControl && <ViewControl />}</Navbar>
    </Fragment>
  );
};

export default HeaderBar;
